import { render, staticRenderFns } from "./ResetNumberingAskForNextNumber.vue?vue&type=template&id=1d8b133b"
import script from "./ResetNumberingAskForNextNumber.vue?vue&type=script&lang=ts"
export * from "./ResetNumberingAskForNextNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports